import axios from '@/plugins/axios.js';

export default {
    async getCampaigns({ commit, rootState }, payload) {
        payload.account_id = rootState.authUser.account.id;

        const response = await axios.get('campaigns', { params: payload });

        commit('setCampaigns', response.data.data);

        return response.data;
    },

    async getCampaign({ commit }, id) {
        const response = await axios.get(`campaigns/${id}`);

        commit('setSelectedCampaign', response.data.data);

        return response.data;
    },

    async getCampaignContacts(store, {
        campaignId,
        search,
        sent,
        withReply,
        page,
        perPage,
    }) {
        const response = await axios.get(`campaigns/${campaignId}/contacts`, {
            params: {
                search,
                sent,
                withReply,
                page,
                perPage,
            },
        });

        return response.data;
    },

    async createCampaign({ commit, rootState }, campaign) {
        const response = await axios.post('campaigns', {
            account_id: rootState.authUser.account.id,
            name: campaign.name,
        });

        commit('addCampaign', response.data.data);

        return response.data.data;
    },

    async updateCampaign({ commit }, campaign) {
        const response = await axios.put(`campaigns/${campaign.id}`, {
            name: campaign.name,
        });

        commit('updateCampaign', response.data.data);
    },

    async deleteCampaign({ commit }, id) {
        await axios.delete(`campaigns/${id}`);

        commit('deleteCampaign', id);
    },
};
